export var CACHE_STATUS;
(function (CACHE_STATUS) {
    CACHE_STATUS["REQUESTED"] = "REQUESTED";
    CACHE_STATUS["LOADED"] = "LOADED";
    CACHE_STATUS["FAILED"] = "FAILED";
})(CACHE_STATUS || (CACHE_STATUS = {}));
export var CONTENT_CACHE_TYPE;
(function (CONTENT_CACHE_TYPE) {
    CONTENT_CACHE_TYPE["CONTENT"] = "CONTENT";
    CONTENT_CACHE_TYPE["THUMBNAIL"] = "THUMBNAIL";
    CONTENT_CACHE_TYPE["PAGES_JSON"] = "PAGES_JSON";
    CONTENT_CACHE_TYPE["HTML_MANIFEST"] = "HTML_MANIFEST";
})(CONTENT_CACHE_TYPE || (CONTENT_CACHE_TYPE = {}));
export var CacheDB;
(function (CacheDB) {
    CacheDB["DB_NAME"] = "CacheDB";
    CacheDB["CACHE_MANIFEST"] = "CACHE_MANIFEST";
    CacheDB["CACHE_PAYLOAD"] = "CACHE_PAYLOAD";
})(CacheDB || (CacheDB = {}));
//# sourceMappingURL=cacheDB.js.map